var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Collapse',{attrs:{"guides":_vm.guides}})
}
var staticRenderFns = []

export { render, staticRenderFns }